module.exports = __webpack_public_path__ + "static/img/Viliame-Fifita.ff73454.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Viliame-Fifita.jpg
// module id = 9QV9
// module chunks = 0